import React from 'react';
import { Heart, Star, ShoppingCart } from 'lucide-react';

/**
 * Book card component that displays a single book's information
 */
const BookCard = ({ book, isSelected, onSelect, isFavorite, onToggleFavorite }) => (
  <div className="group bg-white rounded-3xl shadow-xl hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 overflow-hidden">
    <div className="relative">
      <img 
        src={book.image} 
        alt={book.title}
        className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
      />
      <button 
        onClick={() => onToggleFavorite(book.id)}
        className={`absolute top-4 right-4 p-2 rounded-full transition-all duration-300 ${
          isFavorite
            ? 'bg-red-500 text-white' 
            : 'bg-white/80 text-gray-600 hover:bg-red-500 hover:text-white'
        }`}
      >
        <Heart className={`w-5 h-5 ${isFavorite ? 'fill-current' : ''}`} />
      </button>
      
      <div className="absolute top-4 left-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
        {book.category}
      </div>
      
      <div className="absolute bottom-4 left-4 bg-black/70 text-white px-3 py-1 rounded-full backdrop-blur">
        <div className="flex items-center space-x-1">
          <Star className="w-4 h-4 text-yellow-400 fill-current" />
          <span className="text-sm font-semibold">{book.rating}</span>
          <span className="text-xs text-gray-300">({book.reviews})</span>
        </div>
      </div>
    </div>
    
    <div className="p-6">
      <h3 className="font-bold text-xl text-gray-800 mb-2 line-clamp-2">{book.title}</h3>
      <p className="text-gray-600 mb-2 font-medium">{book.author}</p>
      <p className="text-gray-500 text-sm mb-4 line-clamp-2">{book.description}</p>
      
      <div className="flex justify-between items-center mb-4">
        <div className="text-2xl font-bold text-green-600">${book.price}</div>
      </div>
      
      <button
        onClick={() => onSelect(book)}
        className={`w-full py-3 rounded-xl font-semibold transition-all duration-300 flex items-center justify-center space-x-2 ${
          isSelected
            ? 'bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-lg'
            : 'bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 text-white shadow-lg hover:shadow-xl'
        }`}
      >
        <ShoppingCart className="w-5 h-5" />
        <span>{isSelected ? 'Selected!' : 'Add to Cart'}</span>
      </button>
    </div>
  </div>
);

export default BookCard;
